module.exports = __webpack_public_path__ + "static/media/loader-white.a0efa3ec.svg";